import * as React from "react";
import "./pvxFAQs.css";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

export default function PVXFAQs() {
  return (
    <div className="pvxFAQs">
      <div className="frequentlyHead">
        <h1>Frequently Asked Question</h1>
        <p>
          PV Smith is committed to providing exceptional customer service and
          technical support.
        </p>
      </div>
      <div className="pvxFAQsBox">
        <Accordion>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1-content"
            id="panel1-header"
          >
            <Typography component="span">
              Is there a free trial available for Smith PVX Design Tool?
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            Yes, a free trial is available for Smith PVX Design Tool. Simply
            click on "Request Signup" to submit your request. Our PVX team will
            review and approve it, and you will receive an email with your trial
            credentials within 24 hours.
          </AccordionDetails>
        </Accordion>
        <Accordion>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel2-content"
            id="panel2-header"
          >
            <Typography component="span">
              Where can I find the pricing plans for SMITH PVX Design Tool?
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            You can explore our pricing plans and current offers by clicking on
            the following link: <a href="###">SMITH PVX Pricing</a>.
            Alternatively, you can find the "Pricing" tab in the navigation bar
            on our website to check the available plans.
          </AccordionDetails>
        </Accordion>
        <Accordion>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1-content"
            id="panel1-header"
          >
            <Typography component="span">
              Can I add specific panels or inverters upon request?
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            Yes, absolutely! We can add specific panels or inverters upon your
            request. Simply provide us with the data sheets for the components
            you want to include, and we will integrate them into the system for
            you.
          </AccordionDetails>
        </Accordion>
        <Accordion>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1-content"
            id="panel1-header"
          >
            <Typography component="span">
              Can I design multiple roof layouts within a single project?
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            Yes, you can create and manage multiple roof layouts in a single
            project, ensuring flexibility in design and system optimization.
          </AccordionDetails>
        </Accordion>
        <Accordion>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1-content"
            id="panel1-header"
          >
            <Typography component="span">
              Why is customer data required? Can I proceed without it?
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            Customer details help in generating personalized proposals. However,
            your data remains private and secure. If you prefer not to provide
            customer data, you can skip this step.
          </AccordionDetails>
        </Accordion>
      </div>
    </div>
  );
}
